import React from 'react';
import ServiceItem from './ServiceItem';
const services = [
    {
        title: 'Web Design',
        text: 'Design Attractive and High User Friendly Websites.'
    },
    {
        title: 'Web Development',
        text: 'Develop High Secure and Dynamic Websites.'
    },
    {
        title: 'SEO Optimization',
        text: 'Make The Website SEO Friendly.'
    },
];

const Service = () => {
    return (
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What I offer</span>

            <div className="service__container container grid" id='service-con'>
                {
                    services.map((item, idx) => (
                        <ServiceItem key={idx} value={item}/>
                    ))
                }
            </div>
        </section>
    )
}

export default Service;